'use client';

import { memo } from 'react';

import SvgIcon from '@mui/material/SvgIcon';

// ----------------------------------------------------------------------

function Madacard({ sx, ...other }) {
  return (
    <SvgIcon
      fill="none"
      // viewBox="0 0 144 62"
      xmlns="http://www.w3.org/2000/svg"
      sx={[
        {
          width: 30,
          height:30,
          color: 'background.error',
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 50">
        <path d="M0,29.15H64.14V50.54H0Z" fill="#82bc00" />
        <path d="M0,0H64.14V21.38H0Z" fill="#00a1df" />
      </svg>
    </SvgIcon>
  );
}

export default Madacard;
